import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { FixedExtend } from '../../config/fixed-extend';
import { AlertService } from '../../providers/alert.service';
import { BettingService } from '../../services/betting.service';
import { NormalReportService } from '../../services/normalreport.service';
import { ResumeOrderDetail } from '../../models/betting.model';


@Component({
  selector: 'page-continue-betting',
  templateUrl: 'continue-betting.html',
  providers:[NormalReportService,BettingService]
})
export class ContinueBettingPage {
  onlyValue: any;
  order: ResumeOrderDetail = new ResumeOrderDetail();
  // 倍数
  Multiple = 1;
  parameter;
  bettingInfoIssues;
  brickContent: string = "";
  resumeNo: string = "";
  // 倒计时
  remainTime: any;
  bettingMoneyCount;
  issueinfo;
  changeBettingMoney;
  timer: any;
  constructor(
    private viewCtrl: ViewController,
    private navpar: NavParams,
    private normalreport: NormalReportService,
    private bettingService: BettingService,
    private alert: AlertService,
    private indexExtend: FixedExtend
  ) {
    this.onlyValue = this.navpar.data.report;
    this.Multiple = this.onlyValue.Multiple;
  }
  ionViewDidLoad() {
    let playModeType = Number(this.onlyValue.PlayModeType) || 0;
    this.normalreport.getOrderDetail(this.onlyValue.BettingID, playModeType).then((s) => {
      this.order = s;
      this.Multiple = this.onlyValue.Multiple || 1;
      this.changeBettingMoney = this.indexExtend.accMul(
        this.indexExtend.accDiv(
          this.order.BettingMoney,
          this.onlyValue.Multiple
        ),
        this.Multiple
      );
      if (playModeType == 1) {
        this.order.BettingItems = this.order.BettingItems || [];
        this.order.BettingInfoIssues = this.order.BettingInfoIssues || [];
        this.brickContent = this.order.BettingItems.map((item) => {
          return (item.Position || item.PlayGroup || "") + " "
            + (item.BettingNumber || item.BettingContent || "");
        }).join("，");
      }
      this.bettingService.getIssue(this.order.LotteryCode).then((res) => {
        this.resumeNo = res.CurrentIssueNo;
        this.remainTime = res.RemainTime / 1000;
        this.timer = setInterval(() => {
          this.remainTime--;
          if (this.remainTime <= 0) {
            this.remainTime = 0;
            clearInterval(this.timer);
          }
        }, 1000);
        if (playModeType == 0) {
          let issue = s.Issues[0];
          this.parameter = {
            BettingMoney: this.changeBettingMoney,
            BettingNumber: this.order.BettingNumber,
            BuyIssueCount: this.order.BuyIssueCount,
            GraduationCount: this.order.GraduationCount,
            IsChaseNo: false,
            IssueNo: this.resumeNo,
            LotteryCode: this.order.LotteryCode,
            LotteryPlayDetailCode: this.order.PlayCode,
            Multiple: this.Multiple,
            RuleName: this.order.PlayName,
            SelectMedian: this.order.SelectMedian,
            BettingInfoIssueList: [{
              IssueNo: this.resumeNo,
              Multiple: issue.Multiple,
              PerPrice: issue.PerPrice,
            }],
          };
        }
      });
    });
  }




  getSubmitBetting() {
    if (this.remainTime <= 0) {
      this.alert.showAlert("当前期已过期");
      return;
    }
    if ((Number(this.onlyValue.PlayModeType) || 0) == 1) {
      this.submitCreditBetting();
      return;
    }
    this.parameter.BettingMoney = this.indexExtend.accMul(
      this.indexExtend.accDiv(this.order.BettingMoney, this.onlyValue.Multiple),
      this.Multiple
    );
    this.parameter.BettingInfoIssueList[0].Multiple = this.Multiple;
    this.parameter.Multiple = this.Multiple;
    this.bettingService.betting(this.parameter).then((res) => {
      if (res.Result) {
        this.dismiss();
      }
      this.alert.showAlert(res.Error || (res.Result ? "投注成功" : "投注失败"));
    });
  }

  submitCreditBetting() {
    let issue = this.order.BettingInfoIssues[0];
    if (!issue) {
      this.alert.showAlert("原订单缺少投注明细");
      return;
    }
    let items;
    try {
      items = typeof issue.BettingItems == "string"
        ? JSON.parse(issue.BettingItems)
        : issue.BettingItems;
    } catch (e) {
      this.alert.showAlert("原订单投注明细格式错误");
      return;
    }
    items = items || this.order.BettingItems || [];
    let itemString = items.map((item, index) => {
      let position = item.PlayGroup;
      let content = item.BettingNumber;
      if (this.order.LotteryPlayModeName == "二字定位"
        || this.order.LotteryPlayModeName == "三字定位") {
        position = item.BettingPosition;
        content = item.BettingContent;
      } else if (this.order.LotteryPlayModeName == "组选三"
        || this.order.LotteryPlayModeName == "组选六") {
        content = item.BettingContent;
      }
      return [
        item.LotteryPlayDetailCode,
        index + 1,
        position,
        content,
        item.BettingMoney,
        item.AwardMode,
        item.Odds,
        item.Rebate * 10
      ].join("@");
    }).join("|");
    let bettingMoney = this.indexExtend.accMul(
      this.indexExtend.accDiv(issue.BettingMoney, issue.Multiple),
      this.Multiple
    );
    let issueString = [
      this.resumeNo,
      this.Multiple,
      issue.PerPrice,
      bettingMoney
    ].join("@");
    let order = {
      noteTotal: this.order.BettingItemCount || items.length,
      BettingMoney: bettingMoney,
      IssueNo: this.resumeNo,
      LotteryCode: this.order.LotteryCode,
      IsChaseNo: 0,
      LotteryPlayModeCode: this.order.LotteryPlayModeCode,
      IsStopAfterWinning: 0,
      BettingInfoIssueList: [],
      BettingItemString: itemString,
      BettingInfoIssueString: issueString,
      BettingItemList: []
    };
    this.bettingService.dollarBetting(order).then((res) => {
      if (res.Result) {
        this.dismiss();
      }
      this.alert.showAlert(res.Error || (res.Result ? "投注成功" : "投注失败"));
    });
  }

  // 倍数自减
  subtract() {
    if (this.Multiple > 1) {
      this.Multiple--;
      this.changeBettingMoney = this.indexExtend.accMul(
        this.indexExtend.accDiv(
          this.order.BettingMoney,
          this.onlyValue.Multiple
        ),
        this.Multiple
      );
    } else {
      this.Multiple = 1;
      this.changeBettingMoney = this.indexExtend.accMul(
        this.indexExtend.accDiv(
          this.order.BettingMoney,
          this.onlyValue.Multiple
        ),
        this.Multiple
      );
    }
  }
  add() {
    this.Multiple++;
    this.changeBettingMoney = this.indexExtend.accMul(
      this.indexExtend.accDiv(this.order.BettingMoney, this.onlyValue.Multiple),
      this.Multiple
    );
  }

  dismiss() {
    clearInterval(this.timer);
    this.viewCtrl.dismiss();
  }

  changeMultiple(ev) {
    if (ev) {
      this.changeBettingMoney = this.indexExtend.accMul(
        this.indexExtend.accDiv(
          this.order.BettingMoney,
          this.onlyValue.Multiple
        ),
        ev
      );
    } else {
      this.Multiple = 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/normalreport/continue-betting.ts